/* eslint-disable */
import {
  greenThemeLight,
  greenThemeDark,
  blueThemeDark,
  purpleThemeLight,
  purpleThemeDark,
} from "../theme/theme";

import React, { useState } from "react";

const arr = [
  greenThemeLight,
  greenThemeDark,
  blueThemeDark,
  purpleThemeLight,
  purpleThemeDark,
];

var trig = 2;

export const themeData = {
  theme: arr[trig],
};

// Choose theme from above
